
import Vue, {PropType} from "vue";
import {CHF} from "kistenkonfigurator/build/util/currency-util";
import {SimpleAttributeValue} from "../../../model/cart/LocalCartItem";

export default Vue.extend({
  name: "CurrencyAttributeValue",
  props: {
    attrValue: {
      type: Object as PropType<SimpleAttributeValue>,
      default: () => ({
        value: "",
      }),
    },
  },
  computed: {
    currency(): string {
      return CHF(this.attrValue.value).format();
    },
  },
});
